const Terms = () => {
  return (
    <div style={{ width: '90%', maxWidth: 725, margin: 'auto' }}>
      <p>
        <strong>RENTAL AGREEMENT</strong>
      </p>
      <p>
        RENTAL TERMS AND CONDITIONS
        <br /> <br /> 1. The RENTER shall keep and maintain the rented Digital
        Software during the terms of the rental at his own cost and expense. He
        shall keep the Digital Software in good faith, without altering,
        analyzing, or otherwise tampering without the program files or key
        information.
        <br /> <br /> 2. The RENTER shall pay the OWNER full compensation for
        and/or repair of any digital software which is not returned because it
        is suspended, banned, or otherwise compromised such that the original
        owner is unable to use it without encumbrance. The OWNER’s invoice for
        replacement or repair is conclusively decided as the fair market value
        of the software at the time the software is compromised.
      </p>
      <ol start={3}>
        <li>
          The RENTER shall inform the OWNER upon demand of the exact location
          and status of the Digital Software while it is in the RENTERS’s
          possession
        </li>
        <li>
          The Digital Software shall be delivered to RENTER and returned to
          OWNER at the RENTER’s risk, cost and expense. If a periodic rental
          rate is charged by OWNER, rental charges are billed to the RENTER for
          each period or portions of the period form the time the Digital
          Software is delivered to RENTER until its return. If a term rental
          rate is charged by OWNER, rental charges are billed to the RENTER for
          the full term even if the Digital Software is returned before the end
          of the term. If the Digital Software is not returned during or at the
          end of the term, then the rental charges shall continue on a full-term
          basis for any additional term or portion thereof until the Digital
          Software is returned.
        </li>
        <li>
          No allowance will be made for any rented Digital Software or portion
          thereof which is claimed not to have been used. Acceptance of returned
          Digital Software by OWNER does not constitute a waiver of any of the
          rights OWNER has under the rental agreement.
        </li>
        <li>
          If the RENTER is in default of any of the terms and conditions of this
          agreement, the OWNER, and his agents, at the RENTER’s risk, cost and
          expense may at any time intervene and recover the rented Digital
          Software.
        </li>
        <li>
          The RENTER shall not pledge or encumber the rented Digital Software in
          any way. The OWNER may terminate this agreement immediately upon the
          failure of RENTER to make rental payments when due, or upon RENTER’s
          filling for protection from creditors in any court of competent
          jurisdiction.
        </li>
        <li>
          The OWNER makes no warranty of any kind regarding the rented Digital
          Software, except that OWNER shall replace the Digital Software with
          identical or similar Digital Software if the Digital Software fails to
          operate in accordance with the digital software companies’
          specifications and operation instructions. Such replacement shall be
          made as soon as practicable after RENTER returns the non-conforming
          Digital Software.
        </li>
        <li>
          RENTER indemnifies and holds OWNER harmless for all injuries or damage
          of any kind for repossession and for all consequential and special
          damages for any claimed breach of warranty.
        </li>
        <li>
          The RENTER shall pay all reasonable attorney and other fees, the
          expenses and costs incurred by OWNER in protection its rights under
          this rental agreement and for any action taken OWNER to collect any
          amounts due the OWNER under this rental agreement.
        </li>
        <li>
          These terms are accepted by the RENTER upon delivery of the terms to
          the RENTER or the agent or other representative of RENTER.
        </li>
        <li>
          The RENTER agrees to fair use of the product, which includes agreement
          to not alter, substantially change, or otherwise crack or distribute
          the software. Any attempt to do so will be considered a breach of this
          agreement, and result in the immediate termination of the agreement
          without refund. Additionally, should the RENTER jeopardize or
          otherwise prevent the OWNER from use of the product, the RENTER is
          subject to all legal remedies available in accordance with this
          agreement.
        </li>
        <li>
          We may, at any time, and at our sole discretion, modify these Terms
          and Conditions of Use, including our Privacy Policy, with or without
          notice to the User. Any such modification will be effective
          immediately upon public posting. Your continued use of our Service and
          this Site following any such modification constitutes your acceptance
          of these modified Terms.
        </li>
        <li>
          CHOICE OF LAW – All issues and questions concerning the construction,
          validity, enforcement and interpretation of this Agreement and the
          exhibits and schedules hereto shall be governed by, and construed in
          accordance with, the laws of the STATE OF NEW HAMPSHIRE, without
          giving effect to any choice of law or conflict of law rules or
          provisions (whether of the State of NEW HAMPSHIRE or any other
          jurisdiction) that would cause the application of the laws of any
          jurisdiction other than the State of NEW HAMPSHIRE.
        </li>
        <li>
          By clicking “I Agree” upon the{' '}
          <a href="https://rentals.botmrt.com/">https://rentals.botmrt.com/</a>{' '}
          page the RENTER agrees he has read through all the terms above, and he
          understands the duties and liabilities associated with this agreement.
          Should the RENTER not be the age of majority, it must be read and
          agreed upon by a legal guardian.
        </li>
      </ol>
      <p> </p>
    </div>
  );
};

export default Terms;
